// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@charset \"UTF-8\";\n.custom-column .selected-options[data-v-7f9e81e4]:after {\n  content: \"、\";\n}\n.custom-column .selected-options[data-v-7f9e81e4]:last-child {\n  content: \"\";\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
